/**
 * @file src/core/dispose.js
 * Dispose sâu một Object3D: geometry + material + mọi texture trong material.
 * Nâng từ three-lessons/src/core/dispose.js, bổ sung: render target, skeleton,
 * và đếm số thứ đã dispose để debug.
 */

/**
 * @param {import('three').Object3D | null | undefined} root
 * @returns {{ geometries: number, materials: number, textures: number }}
 */
export function disposeObject3D(root) {
  const stat = { geometries: 0, materials: 0, textures: 0 };
  if (!root) return stat;

  root.traverse((o) => {
    const any = /** @type {any} */ (o);

    if (any.isMesh || any.isLine || any.isPoints || any.isSprite) {
      if (any.geometry?.dispose) {
        any.geometry.dispose();
        stat.geometries++;
      }
      const mat = any.material;
      if (Array.isArray(mat)) {
        for (const m of mat) disposeMaterial(m, stat);
      } else {
        disposeMaterial(mat, stat);
      }
    }

    if (any.isSkinnedMesh && any.skeleton?.dispose) any.skeleton.dispose();
  });

  if (root.parent) root.parent.remove(root);
  return stat;
}

/**
 * @param {any} mat
 * @param {{ geometries: number, materials: number, textures: number }} stat
 */
function disposeMaterial(mat, stat) {
  if (!mat) return;
  for (const key in mat) {
    const v = mat[key];
    if (v && v.isTexture && typeof v.dispose === 'function') {
      v.dispose();
      stat.textures++;
    }
  }
  if (typeof mat.dispose === 'function') {
    mat.dispose();
    stat.materials++;
  }
}
